import React from 'react';
import { ScaleIcon, PenToolIcon, BarChart3Icon, GlobeIcon } from 'lucide-react';
export function StrategicRibbon() {
  const capabilities = [{
    name: 'Policy Analysis',
    icon: ScaleIcon
  }, {
    name: 'Content Strategy',
    icon: PenToolIcon
  }, {
    name: 'M&E Dashboards',
    icon: BarChart3Icon
  }, {
    name: 'Market Entry',
    icon: GlobeIcon
  }];
  return <div className="bg-navy w-full shadow-md relative z-20" data-id="element-171">
      <div className="max-w-7xl mx-auto" data-id="element-172">
        <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-white/10 border-y border-white/10" data-id="element-173">
          {capabilities.map((item, index) => {
          const Icon = item.icon;
          return <div key={index} className="flex items-center justify-center space-x-3 h-20 px-4 group cursor-pointer hover:bg-white/5 transition-colors" data-id="element-174">
                <Icon className="h-5 w-5 text-gold group-hover:scale-110 transition-transform duration-300" data-id="element-175" />
                <span className="font-sans font-semibold text-xs md:text-sm text-white uppercase tracking-wider" data-id="element-176">
                  {item.name}
                </span>
              </div>;
        })}
        </div>
      </div>
    </div>;
}